import "./venues.css";

import React from "react";
import { Button } from "@material-ui/core";
import { Link } from "react-router-dom";
import { Helmet } from "react-helmet";

import { PAGE_ROUTES } from "../../utils/stateTypes";
import Header from "../sections/Header";
import LineSeparator from "../sections/LineSeparator";
import BlockHeading from "../sections/BlockHeading";

const styles = {
  viewButton: {
    position: "absolute",
    bottom: 10,
    left: 10,
    right: 10,
    color: "#fff",
    borderColor: "#fff",
    backgroundColor: "rgba(0, 0, 0, 0.3)",
    textTransform: "none",
  },
};


const Venues = () => {
  return (
    <div>
      <Helmet>
        <title>Our Venues | The Shepstone Experience</title>
        <meta
          name={"description"}
          content={"Discover the magical Shepstone Gardens and the awe-inspiring Great Hall."}
        ></meta>
      </Helmet>
    
      <Header
        bgImg={"/images/venue_header-4.jpg"}
        headText={"OUR VENUES"}
      />

      <section className={"venue-picker-section"}>

        <BlockHeading
          headText={"Choose one of our offerings to see more"}
          noBorder
        />
        <LineSeparator />
        <LineSeparator noLine />

        <div className={"venue-picker-cont standard-width"}>
          <Link to={PAGE_ROUTES.VENUES_SHEP}>
            <div className={"venue-picker-item"}>
              <h3>Shepstone Gardens</h3>
              <img src={"/images/venue-picker-shepstone-2.jpg"} />
              <Button
                variant={"outlined"}
                style={styles.viewButton}
              >
                VIEW
              </Button>
            </div>
          </Link>
          <Link to={PAGE_ROUTES.VENUES_HALL}>
            <div className={"venue-picker-item"}>
              <h3>The Great Hall</h3>
              <img src={"/images/venue-picker-great-hall-2.jpg"} />
              <Button
                variant={"outlined"}
                style={styles.viewButton}
              >
                VIEW
              </Button>
            </div>
          </Link>
          <Link to={PAGE_ROUTES.VENUES_LATITUDES}>
            <div className={"venue-picker-item"}>
              <h3>Latitudes Centre for the Arts</h3>
              <img src={"/images/latitudes/latitudes-01.jpg"} />
              <Button
                variant={"outlined"}
                style={styles.viewButton}
              >
                VIEW
              </Button>
            </div>
          </Link>
          <Link to={PAGE_ROUTES.VENUES_SPA}>
            <div className={"venue-picker-item"}>
              <h3>Shepstone Spa</h3>
              <img src={"/images/spa/spa-01.jpg"} />
              <Button
                variant={"outlined"}
                style={styles.viewButton}
              >
                VIEW
              </Button>
            </div>
          </Link>
          <Link to={PAGE_ROUTES.VENUES_EXTERNAL}>
            <div className={"venue-picker-item"}>
              <h3>External Events</h3>
              <img src={"/images/venue-picker-external.jpg"} />
              <Button
                variant={"outlined"}
                style={styles.viewButton}
              >
                VIEW
              </Button>
            </div>
          </Link>
        </div>
      </section>

    </div>
  );
};

export default Venues;

